module.exports = __webpack_public_path__ + "img/top.712b3a6b.png";